/* tslint:disable */
/* eslint-disable */
/**
 * re-order
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Article } from './Article';
import {
    ArticleFromJSON,
    ArticleFromJSONTyped,
    ArticleToJSON,
} from './Article';
import type { Customer } from './Customer';
import {
    CustomerFromJSON,
    CustomerFromJSONTyped,
    CustomerToJSON,
} from './Customer';
import type { SalesWrapLastSelected } from './SalesWrapLastSelected';
import {
    SalesWrapLastSelectedFromJSON,
    SalesWrapLastSelectedFromJSONTyped,
    SalesWrapLastSelectedToJSON,
} from './SalesWrapLastSelected';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface SalesWrap
 */
export interface SalesWrap {
    /**
     * 
     * @type {string}
     * @memberof SalesWrap
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesWrap
     */
    status?: SalesWrapStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SalesWrap
     */
    annotation?: string;
    /**
     * 
     * @type {Date}
     * @memberof SalesWrap
     */
    deliveryDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SalesWrap
     */
    pickingDate?: Date;
    /**
     * 
     * @type {User}
     * @memberof SalesWrap
     */
    user?: User;
    /**
     * 
     * @type {Array<Article>}
     * @memberof SalesWrap
     */
    articles?: Array<Article>;
    /**
     * 
     * @type {Customer}
     * @memberof SalesWrap
     */
    customer?: Customer;
    /**
     * 
     * @type {number}
     * @memberof SalesWrap
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesWrap
     */
    quantityBooked?: number;
    /**
     * 
     * @type {SalesWrapLastSelected}
     * @memberof SalesWrap
     */
    lastSelected?: SalesWrapLastSelected;
}


/**
 * @export
 */
export const SalesWrapStatusEnum = {
    PartiallyPicked: 'PARTIALLY-PICKED',
    PartiallyDelivered: 'PARTIALLY-DELIVERED',
    Finished: 'FINISHED',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type SalesWrapStatusEnum = typeof SalesWrapStatusEnum[keyof typeof SalesWrapStatusEnum];


/**
 * Check if a given object implements the SalesWrap interface.
 */
export function instanceOfSalesWrap(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SalesWrapFromJSON(json: any): SalesWrap {
    return SalesWrapFromJSONTyped(json, false);
}

export function SalesWrapFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesWrap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'annotation': !exists(json, 'annotation') ? undefined : json['annotation'],
        'deliveryDate': !exists(json, 'deliveryDate') ? undefined : (new Date(json['deliveryDate'])),
        'pickingDate': !exists(json, 'pickingDate') ? undefined : (new Date(json['pickingDate'])),
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'articles': !exists(json, 'articles') ? undefined : ((json['articles'] as Array<any>).map(ArticleFromJSON)),
        'customer': !exists(json, 'customer') ? undefined : CustomerFromJSON(json['customer']),
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'quantityBooked': !exists(json, 'quantityBooked') ? undefined : json['quantityBooked'],
        'lastSelected': !exists(json, 'lastSelected') ? undefined : SalesWrapLastSelectedFromJSON(json['lastSelected']),
    };
}

export function SalesWrapToJSON(value?: SalesWrap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'status': value.status,
        'annotation': value.annotation,
        'deliveryDate': value.deliveryDate === undefined ? undefined : (value.deliveryDate.toISOString()),
        'pickingDate': value.pickingDate === undefined ? undefined : (value.pickingDate.toISOString()),
        'user': UserToJSON(value.user),
        'articles': value.articles === undefined ? undefined : ((value.articles as Array<any>).map(ArticleToJSON)),
        'customer': CustomerToJSON(value.customer),
        'quantity': value.quantity,
        'quantityBooked': value.quantityBooked,
        'lastSelected': SalesWrapLastSelectedToJSON(value.lastSelected),
    };
}

